import { createFileRoute, Navigate } from '@tanstack/react-router'
import { usePermissions } from '@/hooks/usePermissions'
import { firstAllowedPath } from '@/lib/navigation'
import { NoAccessNotice } from '@/components/NoAccessNotice'

export const Route = createFileRoute('/')({
  component: IndexRedirect,
})

function IndexRedirect() {
  const { hasPermission, isLoading } = usePermissions()

  if (isLoading) {
    return null
  }

  const target = firstAllowedPath(hasPermission)
  return target ? <Navigate to={target} replace /> : <NoAccessNotice />
}
